import React, { useEffect, useRef, useState } from 'react';
import { NoRecords, PageLoader } from '../../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ArrowDown, ArrowUp, Search, Check, Copy, ExternalLink, Eye, CheckIcon } from 'lucide-react';
import moment from 'moment';
import { useDebounce } from '../../../hooks/debounce';
import { formatAddress } from '../../../utils/formatAddress';
import { useGetTransaction } from '../api/withdrawApi';
import PermissionDenied from '../../common/permissionDenied';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import { useToast } from '../../../hooks/usetoast';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { transactionurl } from '../../../lib/transactionurl';
import { useModalContext } from '../../../contexts/ModalContext';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';
import { Box, Modal, Typography } from '@mui/material';
import { displayValue } from '../../../hooks/export';

function EthWithdraw() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc");
    const searchText = useDebounce(search);
    let type = "Withdraw";
    let currency = "eth";
    let network = "ethereum";

    const [access, setAccess] = useState(true);
    const [addressdouble, setAddressdouble] = useState(false);
    const [userAddress, setUserAddress] = useState(false);
    const toast = useToast();
    const { theme } = useModalContext();

    const { data: getTransactionList, isLoading } = useGetTransaction({
        page: searchText ? 0 : tempPage, size: tempRows, sortOrder: sortOrder, searchText, sortField: '_id', type, currency, network
    });

    const totalRecords = getTransactionList?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);


    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    // View Full Withdraw Details //

    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const Viewdetails = (row) => {
        setModalData(row);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setModalData(null);
    };

    const userTxnUrl = transactionurl["eth"] + modalData?.txnHash;
    const adminTxnUrl = transactionurl["eth"] + modalData?.admin_trans_txnHash;

    //

    const checkAdminMutation = useCheckAdminAccess();

    React.useEffect(() => {
        const checkAdminAccess = async () => {
            try {
                const obj = { page: 'Send Management' };
                const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
                if (!checkAdminRes?.data?.status) {
                    setAccess(false);
                    logout();
                } else {
                    setAccess(true);
                }
            } catch (error) {
                setAccess(false);
            }
        };
        checkAdminAccess();
    }, []);


    const copyuseraddress = async data => {
        setUserAddress(data._id);
        await copyToClipboard(data.address);
        toast.success("Address copied");
        setTimeout(() => {
            setUserAddress();
        }, 800);
    };

    const copyAdminTxnHashAddress = async data => {
        setAddressdouble(data._id);
        await copyToClipboard(data.admin_trans_txnHash);
        toast.success("Txn Hash copied");
        setTimeout(() => {
            setAddressdouble();
        }, 800);
    };

    const copyUserTxnHashAddress = async (data) => {
        setUserAddress(data._id);
        await copyToClipboard(data.txnHash);
        toast.success("Txn Hash copied");
        setTimeout(() => {
            setUserAddress("");
        }, 800);
    };

    const renderWithdrawStatus = (withdrawStatus) => {
        let statusClass = "text-success";

        if (withdrawStatus === "Rejected") {
            statusClass = "text-danger";
        }
        if (withdrawStatus === "Pending") {
            statusClass = "text-warning";
        }

        return <p className={statusClass}>{withdrawStatus}</p>;
    };


    const renderTxnCell = (admin_trans_txnHash, isAdminTxnAddress, row, txnUrl, copyAdmintxnhashAddress) => {
        if (!admin_trans_txnHash) return "-";

        const txnHashShortened = `${admin_trans_txnHash.slice(0, 3)}...${admin_trans_txnHash.slice(-3)}`;

        return (
            <>
                {txnHashShortened}
                {isAdminTxnAddress ? (
                    <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                ) : (
                    <Copy
                        onClick={() => copyAdmintxnhashAddress(row)}
                        size={20}
                        className="ml-5"
                        style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                    />
                )}
                <a href={txnUrl} target="_blank" rel="noopener noreferrer" className="ml-2">
                    <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                </a>
            </>
        );
    };

    const renderModalTxnCell = (
        hash,
        isVerified,
        row,
        txnUrl,
        onCopy,
        theme
    ) => {
        if (!hash) return "-";

        const txnHashShortened = `${hash.slice(0, 4)}...${hash.slice(-4)}`;

        return (
            <>
                {txnHashShortened}
                {isVerified ? (
                    <CheckIcon size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                ) : (
                    <Copy
                        onClick={() => onCopy(row)}
                        size={20}
                        className="ml-5"
                        style={{
                            cursor: "pointer",
                            marginLeft: "5px",
                            color: theme ? "white" : "black",
                        }}
                    />
                )}
                <a href={`${txnUrl}/${hash}`} target="_blank" rel="noopener noreferrer" className="ml-2">
                    <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                </a>
            </>
        );
    };




    const renderWhitelistIpTable = () => (
        getTransactionList?.data?.data?.length > 0 ?
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">USER ADDRESS</TableCell>
                                    <TableCell align="center"> Amount</TableCell>
                                    <TableCell align="center">Fees</TableCell>
                                    <TableCell align="center">Received Amount</TableCell>
                                    <TableCell align="center">Transaction Hash</TableCell>
                                    <TableCell align="center">Date & Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                    <TableCell align='center'>Status</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getTransactionList?.data?.data?.map((row, i) => {
                                    const {
                                        _id,
                                        address,
                                        updatedAt,
                                        withdrawStatus,
                                        txnHash,
                                        name
                                    } = row;

                                    const formattedAddress = formatAddress(address || "-");
                                    const txnUrl = transactionurl["eth"] + txnHash;
                                    const isUserAddress = userAddress === _id;
                                    const isAdminTxnAddress = addressdouble === _id;

                                    return (
                                        <TableRow key={name}>
                                            <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                            <TableCell align="center">{row.userEmail}</TableCell>
                                            <TableCell align="center">
                                                {formattedAddress}
                                                {isUserAddress ? (
                                                    <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                ) : (
                                                    <Copy
                                                        onClick={() => copyuseraddress(row)}
                                                        size={20}
                                                        className="ml-5"
                                                        style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell className="text-nowrap" align="center">
                                                {row?.transferAmount ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                        {displayValue(row.transferAmount, 6)}
                                                        {row?.currencyImage && (
                                                            <img
                                                                src={row.currencyImage}
                                                                alt="Currency Icon"
                                                                style={{
                                                                    height: '20px',
                                                                    width: '20px',
                                                                    borderRadius: '50%',
                                                                    verticalAlign: 'middle',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell className="text-nowrap" align="center">
                                                {row?.fee ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                        {displayValue(row.transferAmount, 6)}
                                                        {row?.currencyImage && (
                                                            <img
                                                                src={row.currencyImage}
                                                                alt="Currency Icon"
                                                                style={{
                                                                    height: '20px',
                                                                    width: '20px',
                                                                    borderRadius: '50%',
                                                                    verticalAlign: 'middle',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell className="text-nowrap" align="center">
                                                {row?.sentAmount ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                        {displayValue(row.sentAmount, 6)}
                                                        {row?.currencyImage && (
                                                            <img
                                                                src={row.currencyImage}
                                                                alt="Currency Icon"
                                                                style={{
                                                                    height: '20px',
                                                                    width: '20px',
                                                                    borderRadius: '50%',
                                                                    verticalAlign: 'middle',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell align="center">{renderTxnCell(txnHash, isAdminTxnAddress, row, txnUrl, copyAdminTxnHashAddress)}</TableCell>

                                            <TableCell align="center">{moment(updatedAt).format("DD/MM/YYYY | hh:mm A")}</TableCell>
                                            <TableCell align="center">{renderWithdrawStatus(withdrawStatus)}</TableCell>
                                            <TableCell style={{ whiteSpace: "no-wrap" }} align="center">
                                                <Eye size={20} type='button' onClick={() => Viewdetails(row)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />


                {/* Modal Popup */}
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="withdrawal-modal-title"
                    aria-describedby="withdrawal-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 500,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        borderRadius: 2,
                        p: 4,
                        outline: 'none',
                    }}>

                        {modalData && (
                            <>
                                <Typography id="withdrawal-modal-title" variant="h6" mb={2} fontWeight="bold">
                                    Withdrawal Details
                                </Typography>


                                {/* User Email */}
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>User Email:</strong></Typography>
                                    <Typography>{modalData?.userEmail}</Typography>
                                </Box>

                                {/* Address */}
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Address:</strong></Typography>
                                    <Typography>{formatAddress(modalData?.address)}</Typography>
                                </Box>

                                {/* Status */}
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Status:</strong></Typography>
                                    <Typography
                                        sx={{
                                            color:
                                                modalData?.withdrawStatus === 'Completed'
                                                    ? 'green'
                                                    : modalData?.withdrawStatus === 'Pending'
                                                        ? 'orange'
                                                        : modalData?.withdrawStatus === 'Rejected'
                                                            ? 'red'
                                                            : 'inherit'
                                        }}
                                    >
                                        {modalData?.withdrawStatus}
                                    </Typography>
                                </Box>

                                {/* Txn Hash */}
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Txn Hash:</strong></Typography>
                                    <Typography>
                                        {renderModalTxnCell(
                                            modalData?.txnHash,
                                            false,
                                            modalData,
                                            userTxnUrl,
                                            copyUserTxnHashAddress,
                                            theme
                                        )}
                                    </Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Transfer Amount:</strong></Typography>
                                    <Typography> {displayValue(modalData?.transferAmount, 6)}
                                        <img src={modalData?.currencyImage} alt={modalData?.currencySymbol} width='20px' className=' ms-2' />
                                    </Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Sent Amount:</strong></Typography>
                                    <Typography> {displayValue(modalData?.sentAmount, 6)}
                                        <img src={modalData?.currencyImage} alt={modalData?.currencySymbol} width='20px' className=' ms-2' />
                                    </Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Fee:</strong></Typography>
                                    <Typography>{displayValue(modalData?.fee, 6)}
                                        <img src={modalData?.currencyImage} alt={modalData?.currencySymbol} width='20px' className=' ms-2' />
                                    </Typography>
                                </Box>

                                {/* Admin Txn Hash */}
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography><strong>Admin Txn Hash:</strong></Typography>
                                    <Typography>
                                        {renderModalTxnCell(
                                            modalData?.admin_trans_txnHash,
                                            false,
                                            modalData,
                                            adminTxnUrl,
                                            copyAdminTxnHashAddress,
                                            theme
                                        )}
                                    </Typography>
                                </Box>

                                {/* Rejection Reason */}
                                {modalData?.withdrawStatus === 'Rejected' && (
                                    <Box display="flex" justifyContent="space-between" mb={1} color="red">
                                        <Typography><strong>Reason:</strong></Typography>
                                        <Typography>{modalData?.reason}</Typography>
                                    </Box>
                                )}
                            </>
                        )}

                    </Box>
                </Modal>
                {/* Modal Popup */}
            </>
            : <NoRecords />
    );

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <div>
                <h4>Send ETH History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-md-4">
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color="#aaa9a9" />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Address"
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {isLoading ? <PageLoader /> : renderWhitelistIpTable()}
                </div>
            </div>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

export default EthWithdraw;